<template>
  <v-tabs right slider-color="secondary">
    <template v-for="(category, key) in data">
      <v-tab class="text--primary" :key=key>{{ t({s: `tabs.${category[0]}`, component: 'Information'}) }}</v-tab>
      <v-tab-item :key="key+'item'">
        <InformationSection :data="category[1]"/>
      </v-tab-item>
    </template>
  </v-tabs>
</template>

<script>
import InformationSection from '@/components/Information/InformationSection'
import { portal, installation, marketing, app } from '@/assets/data/informationView'

export default {
  name: 'Tabs',
  components: { InformationSection },
  data: () => ({
    data: [
      ['installation', installation],
      ['portal', portal],
      ['app', app],
      ['marketing', marketing]
    ]
  })
}
</script>
